import React, { createContext, useCallback, useEffect, useMemo, useState } from "react";
import {
  EDIT,
  EDITBASICINFO,
  EDITMEDICALINFO,
  PROFILE,
  OPENCONSULTATION,
  GET_ALL_CONSULTATION,
  GET_DOCTOR_LIST,
  GETPASTHISTORY,
  GET_CMS,
} from "../API";
import axiosInstance from "../services/axiosInstance";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


export const ProfileContext = createContext();
export const ProfileProvider = ({ children }) => {
  const navigate = useNavigate();
  const TOKEN = localStorage.getItem("userToken");
  const headers = { token: TOKEN }
  const [profile, setProfile] = useState({});
  const [hasSubbmittedHistory, setHasSubbmittedHistory] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [chatCred, setchatCred] = useState({});
  const [chatMessage, setChatMessage] = useState([]);
  const [ConsultationHistory, setConsultationHistory] = useState([]);
  const [totalConsultations, setTotalConsultations] = useState(0);
  const [allDoctors, setAllDocotors] = useState([]);
  const [consultationSummary, setConsultationSummary] = useState({ symptoms: '', diagnosis: '', tests: '', followup: '' });
  const [CMS, setCMS] = useState("");

  const clearChatMessage = () => { setChatMessage([]) };

  const keyHandler = (e, allowLeadingZero = false) => {
    const { value } = e.target;
    if (["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key)) { return; }
    if (!/^\d$/.test(e.key)) { e.preventDefault() }
    if (!allowLeadingZero && value.length === 0 && e.key === "0") { e.preventDefault() }
  };

  useEffect(() => {
    if (!TOKEN) return;

    const init = async () => {
      await Promise.all([
        fetchaData(),
        getPastHistory(),
        getAllConsultation(),
        getAllDoctors(),
      ]);
    };

    init();
  }, [TOKEN]);
  useEffect(() => { fetchPolicy() },[])

  const fetchaData = useCallback(async () => {
    try {
      const response = await axiosInstance.get(PROFILE);
      setProfile(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getPastHistory = useCallback(async () => {
    try {
      const response = await axiosInstance.get(GETPASTHISTORY, { headers });
      setHasSubbmittedHistory(response.data.data.hasSubmittedPastMedicalHistory);
    } catch (error) {
      console.log(error);
    }
  }, [headers]);

  const getAllConsultation = useCallback(async (page = 1, limit = 10) => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(GET_ALL_CONSULTATION, {
        headers: { token: TOKEN },
        params: { page, limit }
      });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        setConsultationHistory(json.data.consultations);
        setTotalConsultations(json.data.total);
      }
    } catch (err) {
      console.error('fetch error:', err);
    } finally {
      setIsLoading(false);
    }
  }, [TOKEN]);

  const getAllDoctors = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(GET_DOCTOR_LIST);
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        setAllDocotors(json.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const editPersonalInfo = useCallback(async (data) => {
    data.language = "ENGLISH";
    data.file = currentImage;
    try {
      const response = await axiosInstance.put(EDIT, data, { headers: { token: TOKEN, "Content-Type": "multipart/form-data" } });
      if (response.status === 200) {
        toast.success("Profile Updated Successfully");
        navigate("/profile");
      }
    } catch (error) {
      toast.error(error.response?.data?.error);
    }
  }, [currentImage, TOKEN, navigate]);

  const editBasicInfo = useCallback(async (data) => {
    try {
      const response = await axiosInstance.put(EDITBASICINFO, data, { headers });
      if (response.status === 200) navigate("/past-medical-history");
    } catch (error) {
      toast.error(error.response?.data?.error);
    }
  }, [headers, navigate]);

  const editMedicalInfo = useCallback(async (data) => {
    try {
      const response = await axiosInstance.put(EDITMEDICALINFO, data, { headers });
      if (response.status === 200) {
        toast.success("Profile Updated Successfully");
        navigate("/");
      }
    } catch (error) {
      toast.error(error.response?.data?.error);
    }
  }, [headers, navigate]);

  const isProfileIncomplete = (profile) => {
    if (!profile) return true;

    return (
      !profile.dob || !profile.blood_group || !profile.gender || profile.age === 0 || !profile.height || !profile.weight ||
      !profile.primary_care_provider || !profile.pharmacy || (profile.alcohol_history == null && profile.non_alcoholic === false) ||
      (profile.drug_history == null && profile.non_druggist === false) ||
      (profile.social_history == null && profile.never_smoker === false) ||
      (Array.isArray(profile.current_medications) &&
        profile.current_medications.length === 0 &&
        profile.no_medication === false) || (Array.isArray(profile.medication_allergy) &&
          profile.medication_allergy.length === 0 && profile.no_medication_allergy === false)
    );
  };
  const handleConsultationClick = () => {
    if (isProfileIncomplete(profile)) { setShowProfileModal(true) }
    else { navigate("/consultation ") }
  };
  const handleCloseModal = () => { setShowProfileModal(false) };
  const proceedToProfile = () => {
    setShowProfileModal(false);
    navigate("/profile");
  };
  const completeCounsulatation = async () => {
    try {
      const response = await axiosInstance.get(OPENCONSULTATION, { headers });
      if (response.status == 200) {
        const consultation = response.data.data.consultation;
        const chat = response.data.data.chat;
        setchatCred(consultation);
        setChatMessage(chat);
        // setConsulatationId(consultation._id);
        if (Array.isArray(chat) && chat.length > 0) {
          const formattedMessages = chat.map((item) => ({
            id: item._id,
            text: item.message,
            isUser: item.sender === "user",
            timestamp: new Date(item.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }),
          }));
          setChatMessage(formattedMessages);
        }
      }
    }
    catch (error) { console.log(error) }
  };

  const fetchPolicy = async () => {
    try {
      const res = await axiosInstance.get(GET_CMS, { headers });
      if (res.data && res.data.status) {
        setCMS(res.data.data || "");
      }
    }
    catch (err) { console.error("Error fetching privacy policy:", err) }
    finally { setIsLoading(false) }
  };


  const contextValue = useMemo(() => ({
    TOKEN, headers,
    isLoading, setIsLoading,
    profile, setProfile,
    hasSubbmittedHistory, setHasSubbmittedHistory,
    getPastHistory,
    currentImage, setCurrentImage,
    fetchaData, editPersonalInfo, editBasicInfo, editMedicalInfo,
    consultationSummary, setConsultationSummary,
    keyHandler,
    allDoctors,
    showProfileModal, setShowProfileModal,
    proceedToProfile,
    handleCloseModal,
    handleConsultationClick,
    isProfileIncomplete,
    completeCounsulatation,
    chatMessage, setChatMessage,
    chatCred, setchatCred,
    clearChatMessage,
    getAllConsultation,
    ConsultationHistory, setConsultationHistory, totalConsultations,
    CMS
  }), [
    TOKEN, headers, isLoading, profile, hasSubbmittedHistory, currentImage,
    consultationSummary, allDoctors, showProfileModal, chatMessage, chatCred,
    ConsultationHistory, totalConsultations, CMS,
    fetchaData, getPastHistory, editPersonalInfo, editBasicInfo, editMedicalInfo, getAllConsultation
  ]);

  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  );
};
